
<template>
	<div
		v-if="isLoading || (searchStore?.pageData?.results?.length ?? 0) > 0"
		class="ProgrammeCards"
	>
		<ProgrammeCard
			v-for="(programme, programmeIndex) in programmes"
			:key="programmeIndex"
			:programme="programme"
			:loading="isLoading"
			:externalServicesLoading="externalServicesLoading"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ProgrammeCard from './ProgrammeCard/ProgrammeCard.vue';
import { useSearchStore } from '@stores/useSearchStore';
import { useEventAggregation } from '@composables/useEventAggregation';
import type IPersonalizedProgrammeCard from '../../../interfaces/dtos/IPersonalizedProgrammeCard';
import { EVENT_TYPES } from '@app/interfaces/useEventAggregation.interface';

const searchStore = useSearchStore();
useEventAggregation({
	waitFor: [EVENT_TYPES.BestfitOverviewReady, EVENT_TYPES.WishlistServiceReady],
	waitForAll: true,
	onReady: () => searchStore.loadExternalServices()
});

const skeletonCardCount = 20;

const programmes = computed<(IPersonalizedProgrammeCard | undefined)[]>(() => {
	if (searchStore.loading || !searchStore.pageData?.results) {
		return Array.from({ length: skeletonCardCount }, () => undefined);
	}

	return searchStore.pageData.results;
});

const isLoading = computed(() => searchStore.loading);
const externalServicesLoading = computed(() => !searchStore.externalServicesLoaded || searchStore.loading);

</script>

<style scoped lang="scss">
	.ProgrammeCards {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
</style>
